import { type FunctionComponent, type HTMLAttributes } from 'react';
import { type ImageFieldsFragment, type ProductResourceFieldsFragment } from '../../../../__generated__/graphql-client-types';
import { formatPrice } from '../../../../helpers/general-helper/general-helper';
import { CloudinaryImage } from '../../../images/cloudinary-image/cloudinary-image.component';
import CheckIcon from '../../../svgs/untitled-ui/check.svg';
import { optionPill, productOption } from '../product-option.css';

export type OptionPillProps = {
	testId?: string;
	showCheckmark?: boolean;
	startingPrice?: number | null;
	name: string;
	selected?: boolean;
	image: ImageFieldsFragment | null;
	resource?: ProductResourceFieldsFragment | null;
	params?: Record<string, any>;
} & Pick<HTMLAttributes<HTMLElement>, 'className'>;

/**
 * Option Pill Component
 */
export const OptionPill: FunctionComponent<OptionPillProps> = ({
	className = 'w5 ba b--theme-grey-light b--solid br2',
	testId = '',
	name,
	image,
	resource,
	selected,
	startingPrice = null,
	showCheckmark = false
}) => {
	return (
		<div className={`${productOption} ${className ?? ''}`.trim()} data-testid={testId}>
			<div className={`flex flex-row justify-start items-center w-100 w-auto-ns ph2 ${optionPill}`}>
				{image && (
					<CloudinaryImage
						className="pr2"
						publicID={image.id}
						description={image.description}
						options={{ width: 55, height: 55 }}
					/>
				)}

				<div className={`flex flex-column items-start justify-between h-100 w-80 ${showCheckmark ? '' : 'mr2'}`.trim()}>
					<div className="tc2-title tl f6">{name}</div>
					{resource?.price?.current ? (
						<div className="theme-grey f6" data-testid="product-option-price">
							{formatPrice(resource.price.current)}
						</div>
					) : null}
					{startingPrice && <div className="theme-grey f6">Starting at ${startingPrice}</div>}
				</div>
				{showCheckmark && selected && <CheckIcon className="f4 theme-primary pl0 pt2 pb2 pr2" data-testid="CheckIcon" />}
			</div>
		</div>
	);
};
